import type { IntlShape } from "react-intl";
import { z } from "zod";

export function newTopicDataShape(intl: IntlShape) {
  const formDataMessages = {
    required: intl.formatMessage({
      defaultMessage: "O comentário é obrigatório",
      description: "Formulario de inclusão de postagem no fórum",
      id: "IPiMpf",
    }),
    min: intl.formatMessage({
      defaultMessage: "O comentário deve ter no mínimo 3 caracteres",
      description: "Formulario de inclusão de postagem no fórum",
      id: "ZKciSH",
    }),
    max: intl.formatMessage({
      defaultMessage: "O comentário deve ter no máximo 12288 caracteres",
      description: "Formulario de inclusão de postagem no fórum",
      id: "ePKbUl",
    }),
  };

  return z.object({
    title: z
      .string()
      .trim()
      .nonempty(
        intl.formatMessage({
          defaultMessage: "Um título é obrigatório",
          description: "Formulario de inclusão de postagem no fórum",
          id: "jI2mDr",
        }),
      ),
    bodyAsJson: z
      .string()
      .trim()
      .nonempty(formDataMessages.required)
      .min(3, formDataMessages.min)
      .max(8192, formDataMessages.max),
    bodyAsPlainText: z
      .string()
      .trim()
      .nonempty(formDataMessages.required)
      .min(3, formDataMessages.min)
      .max(8192, formDataMessages.max),
  });
}
export type NewTopicData = z.infer<ReturnType<typeof newTopicDataShape>>;

export function editPostTitleInputFormDataShape(intl: IntlShape) {
  return z.object({
    title: z
      .string()
      .trim()
      .nonempty(
        intl.formatMessage({
          defaultMessage: "Um título é obrigatório",
          description: "Edição de título no fórum",
          id: "UHF0P/",
        }),
      ),
  });
}
export type EditPostTitleData = z.infer<ReturnType<typeof editPostTitleInputFormDataShape>>;

export function replyPostInputFormDataShape(intl: IntlShape) {
  const formDataMessages = {
    required: intl.formatMessage({
      defaultMessage: "O comentário é obrigatório",
      description: "Formulario de edição de postagem no fórum",
      id: "y1UKG8",
    }),
    min: intl.formatMessage({
      defaultMessage: "O comentário deve ter no mínimo 3 caracteres",
      description: "Formulario de edição de postagem no fórum",
      id: "Y9rMof",
    }),
    max: intl.formatMessage({
      defaultMessage: "O comentário deve ter no máximo 12288 caracteres",
      description: "Formulario de edição de postagem no fórum",
      id: "OeXMEn",
    }),
  };

  return z.object({
    bodyAsJson: z
      .string()
      .trim()
      .nonempty(formDataMessages.required)
      .min(3, formDataMessages.min)
      .max(8192, formDataMessages.max),
    bodyAsPlainText: z
      .string()
      .trim()
      .nonempty(formDataMessages.required)
      .min(3, formDataMessages.min)
      .max(8192, formDataMessages.max),
  });
}
export type ReplyPostData = z.infer<ReturnType<typeof replyPostInputFormDataShape>>;
